<style>
  .container{
    width: 100%;
    margin-bottom: 20px;
  }
  .navigation{
    padding: 20px 0 20px 10px;
    background-color: #fff;
    margin-bottom: 20px;
    border-bottom: 1px solid #d3dce6;
  }
  .navigation .el-breadcrumb{
    font-size: 16px!important;
  }
   .detailsform .el-form-item {
    margin-bottom: 0px;
  }
</style>

<template>
  <div class="module00299303 container" v-loading='loading'>
    <!--顶部面包屑-->
    <div class="api-defined-navigation">
      <div class="navigation">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>API接口定义</el-breadcrumb-item>
          <el-breadcrumb-item v-if="pageStatus[page] === 2">接口组维护</el-breadcrumb-item>
          <el-breadcrumb-item v-if="pageStatus[page] === 3">接口服务定义</el-breadcrumb-item>
          <el-breadcrumb-item v-if="pageStatus[page] === 3&&objectNavagate.showflag">{{objectNavagate.type}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <!--顶部面包屑 end-->

    <!--首页-->
        <el-card class="api-defined-body" v-if="pageStatus[page] === 1">
          <show-table
            ref="showtable"
            @delItem = 'delGroups'
            @enterdefined = 'enterdefinedAPI'
            @editItem = 'editAPIGroup'
            :queryobj = 'queryObj'
            :queryparam = 'queryParam'
            :showopertbtn = 'showType'>
            <el-button type="primary" icon="plus" size="small" @click="addNewAPIGroup" slot="add">新增接口组</el-button>
          </show-table>
        </el-card>

      <!--首页 end-->

      <!--新增 & 修改 api组页面-->
      <apigroupadd
        v-if="pageStatus[page] === 2"
        :operationtype = 'operationType'
        @goback = 'setPageHome'
        :detaildata="detailData">
      </apigroupadd>

    <!--新增 & 修改 api组页面 end-->

    <!--进入接口定义页面-->
    <apiserverdefined
      :detaildata="detailData"
      v-if="pageStatus[page] === 3"
      @goback = 'setPageHome'
      @addnavigate="addNavigate"></apiserverdefined>
    <!--进入接口定义页面 end-->
  </div>

</template>

<script>
  import  util from '../../../util.js'
  import apigroupadd from './apiGroupsAdd.vue'
  import apiserverdefined from './apiServerDefined.vue'
  import {DataObjectUpdate, bizQueryBatchExecute} from '../../../vuex/actions'
  import {sessionUser} from '../../../vuex/getters'
  export default{
    vuex: {
      getters: {
        sessionUser
      },
      actions: {
        DataObjectUpdate,
        bizQueryBatchExecute
      }
    },
    components:{
      apigroupadd: apigroupadd,
      apiserverdefined: apiserverdefined,
    },
    data() {
      return {
        loading: false,
        objectNavagate:{},
        operationType: "",
        detailData: {},
        pageStatus:{
          home: 1,
          apiAdd: 2,
          apiDefined: 3,
        },
        page: 'home',
        queryObj: {
          queryName: 'OAuthGroups',
          GroupNO: '',
          GroupName: '',
          displayLabel: '接口组编码/名称',
        },
        //table中可以操作的按钮显示与否
        showType: {
          edit: true,
          del: true,
          defined: true,
          export:true
        },
        queryParam: 'GroupNO',
      }
    },
    mounted () {
      this.loadingMsg()
    },
    methods: {
      addNavigate(val){
        this.objectNavagate=val;
      },
      editAPIGroup (data) {
        this.detailData = data
        this.operationType = 'detail'
        this.page = 'apiAdd'
      },
      enterdefinedAPI (data) {console.log(data)
        this.detailData = data
        this.page = 'apiDefined'
      },
      delGroups (data) {
        let obj = {
          BusinessID: 'OAuthGroupDel',
          OperName: this.sessionUser.userName,
          Operator: this.sessionUser.userId,
          ModuleID: this.$route.params.moduleID || '299303',
          ActionNO: 'OAuthGroupDel',
          PaperNO: '',
          //删除需要的参数
          GroupNO: data.GroupNO,
          LastUpdateTime: data.LastUpdateTime,
          Old_LastUpdateTime: data.LastUpdateTime,
        }
        let params = {
          dataList_0: [obj]
        }
        this.$confirm(`确认要删除选择的接口组【${data.GroupNO}】定义吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          this.bizQueryBatchExecute(params, (res) => {
            this.loading = false
            if (res.isValid && res.data.isValid){
              util.success(this, `已删除接口组【${data.GroupNO}】`)
              this.reloading()
            }else{
              util.error(this, '删除失败')
            }
          })
        }).catch(() => {
          console.log('cancel')
        })
      },
      reloading () {
        this.$refs.showtable.searchData()
      },
      loadingMsg () {
        let obj = {
          queryName: 'OAuthGroups',
          GroupNO: '',
          GroupName: '',
        }
        this.DataObjectUpdate
      },
      addNewAPIGroup () {
        this.operationType = 'add'
        this.page = 'apiAdd',
        this.detailData = {}
      },
      setPageHome () {
        this.page = 'home'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// 00299303.vue?361993fd